import { Component } from '@angular/core';

@Component({
    selector: 'app-breadcrumb-user-add',
    templateUrl: './breadcrumb.user.add.component.html'
})

export class BreadcrumbUserAddComponent { }
